import { useRef } from "react";

export const Tilt = ({ as: Tag = "div", max = 8, className = "", children, ...rest }) => {
  const ref = useRef(null);
  const move = (e) => {
    const el = ref.current; if (!el) return;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
    el.style.setProperty("--tx", `${(-y * max).toFixed(2)}deg`);
    el.style.setProperty("--ty", `${(x * max).toFixed(2)}deg`);
    el.style.setProperty("--gx", `${((x + 0.5) * 100).toFixed(1)}%`);
    el.style.setProperty("--gy", `${((y + 0.5) * 100).toFixed(1)}%`);
  };
  const leave = () => {
    const el = ref.current; if (!el) return;
    el.style.setProperty("--tx", "0deg"); el.style.setProperty("--ty", "0deg");
  };
  return <Tag ref={ref} className={`tilt ${className}`} onMouseMove={move} onMouseLeave={leave} {...rest}>{children}</Tag>;
};
